export default __webpack_public_path__ + "images/243be4829d56936549fb45678f058b01.png";